import { useState , useEffect } from "react"
import { get, patch } from "../api"


export function useAllowSalesPersonLogin(){

    const [allowSalesPersonLogin, setAllowSalesPersonLogin] = useState(null)
    const [isLoading , setIsLoading] = useState(false)
    const [error , setError] = useState(false)

    useEffect(()=>{
        //prevent initial loading
        if (allowSalesPersonLogin === null) return
        setIsLoading(true)
        const request = async ()=>{
            try{
                await patch("/core/serverconfig/1" , {allow_sales_person_login:allowSalesPersonLogin})
                setIsLoading(false)
            }catch(error){
                setError(error)
                setIsLoading(false)
            }
        }
       
        request()
    },[allowSalesPersonLogin])


    useEffect( ()=>{
        const fetchData = async  ()=>{ 
            setIsLoading(true)
            try{
                const {allow_sales_person_login} = await get("/core/serverconfig/1")
                setAllowSalesPersonLogin(allow_sales_person_login)
                setIsLoading(false)
            }
            catch(error)
            {
                setError(error)
            }
        } 
    fetchData()},[])

    return { allowSalesPersonLogin , isLoading, setAllowSalesPersonLogin }
}